module.exports = __webpack_public_path__ + "img/pdf.6fef1a9c.svg";